@if (item.action || (!item.image && (item.routerLink === null || item.routerLink === undefined)) || (item.items && item.items.length > 0)) {
  <!-- Button or div for items with an action, without routerLink, or with a submenu -->
  @if (!isSidebarOpen && !item.image && !item.useAvatar) {
    <!-- With tooltip when the sidebar is closed -->
    <app-tooltip
      [tooltipText]="(item.labelKey || item.label) | transloco"
      [tooltipPosition]="'right'"
      [tooltipStyleClass]="'tooltip-sidebar'"
      [showDelay]="300"
      [hideDelay]="0"
      [class.tooltip-enabled]="true">
      <div
        class="item-menu"
        [class.profile-item]="item.image || item.useAvatar"
        [class.root-item]="item.id === 'root'"
        [class.panel-admin-item]="item.id === 'panel-admin'"
        [ngClass]="{ 'active': (!item.image && !item.useAvatar && expanded) || isActive, 'collapsed': !isSidebarOpen }"
        (click)="handleClick($event)">
        <div class="item-content">
          @if (item.useAvatar && item.employeeId) {
            <app-avatar
              [employeeId]="item.employeeId"
              [name]="item.label"
              [size]="48"
              [showInfo]="false"
              class="item-icon avatar-icon">
            </app-avatar>
          } @else if (item.image) {
            <img [src]="item.image" [alt]="item.labelKey | transloco" class="item-icon">
          } @else if (item.svgIcon) {
            <span class="item-icon custom-svg" [innerHTML]="getSanitizedSvg(item.svgIcon)"></span>
          } @else if (item.icon) {
            <lucide-icon [name]="item.icon" class="item-icon"></lucide-icon>
          }
        </div>
      </div>
    </app-tooltip>
  } @else {
    <!-- Without tooltip when the sidebar is open -->
    <div
      class="item-menu"
      [class.profile-item]="item.image || item.useAvatar"
      [class.root-item]="item.id === 'root'"
        [class.panel-admin-item]="item.id === 'panel-admin'"
      [ngClass]="{ 'active': (!item.image && !item.useAvatar && expanded) || isActive, 'collapsed': !isSidebarOpen }"
      (click)="handleClick($event)">
      <div class="item-content">
        @if (item.useAvatar && item.employeeId) {
          <app-avatar
            [employeeId]="item.employeeId"
            [name]="item.label"
            [size]="48"
            [showInfo]="false"
            class="item-icon avatar-icon">
          </app-avatar>
        } @else if (item.image) {
          <img [src]="item.image" [alt]="item.labelKey | transloco" class="item-icon">
        } @else if (item.svgIcon) {
          <span class="item-icon custom-svg" [innerHTML]="getSanitizedSvg(item.svgIcon)"></span>
        } @else if (item.icon) {
          <lucide-icon [name]="item.icon" class="item-icon"></lucide-icon>
        }
        @if (isSidebarOpen) {
          @if (item.useAvatar || item.image) {
            <div class="label-wrapper">
              <span class="item-label">{{ item.label }}</span>
              <p class="profile-subtitle">{{ item.subtitle }}</p>
            </div>
          } @else {
            <span class="item-label">{{ (item.labelKey || item.label) | transloco }}</span>
          }
        }

        @if (item.items && isSidebarOpen && !item.image && !item.useAvatar && item.id !== 'profile') {
          <lucide-icon [name]="expanded ? 'ChevronUp' : 'ChevronDown'" class="item-icon chevron-icon" [class.expanded]="expanded"></lucide-icon>
        }

        <!-- Hover icon for items WITHOUT a submenu -->
        @if (isSidebarOpen && !item.image && !item.useAvatar && item.id !== 'profile' && !item.items) {
          <lucide-icon name="ChevronRight" class="item-icon chevron-icon hover-arrow"></lucide-icon>
        }
      </div>
    </div>
  }
} @else {
  <!-- Normal link for items with routerLink -->
  @if (!isSidebarOpen && !item.image && !item.useAvatar) {
    <!-- With tooltip when the sidebar is closed -->
    <app-tooltip
      [tooltipText]="(item.labelKey || item.label) | transloco"
      [tooltipPosition]="'right'"
      [tooltipStyleClass]="'tooltip-sidebar'"
      [showDelay]="300"
      [hideDelay]="0"
      [class.tooltip-enabled]="true">
      <a
        class="item-menu"
        [class.profile-item]="item.image || item.useAvatar"
        [class.root-item]="item.id === 'root'"
        [class.panel-admin-item]="item.id === 'panel-admin'"
        [routerLink]="!item.image && !item.useAvatar ? item.routerLink : null"
        [routerLinkActive]="!item.image && !item.useAvatar ? 'active-link' : ''"
        [ngClass]="{ 'active': (!item.image && !item.useAvatar && expanded) || isActive, 'collapsed': !isSidebarOpen }"
        (click)="handleClick($event)"
      >
        <div class="item-content">
          @if (item.useAvatar && item.employeeId) {
            <app-avatar
              [employeeId]="item.employeeId"
              [name]="item.label"
              [size]="50"
              [showInfo]="false"
              class="item-icon avatar-icon">
            </app-avatar>
          } @else if (item.image) {
            <img [src]="item.image" [alt]="item.labelKey | transloco" class="item-icon">
          } @else if (item.svgIcon) {
            <span class="item-icon custom-svg" [innerHTML]="getSanitizedSvg(item.svgIcon)"></span>
          } @else if (item.icon) {
            <lucide-icon [name]="item.icon" class="item-icon"></lucide-icon>
          }
        </div>
      </a>
    </app-tooltip>
  } @else {
    <!-- Without tooltip when the sidebar is open -->
    <a
      class="item-menu"
      [class.profile-item]="item.image || item.useAvatar"
      [class.root-item]="item.id === 'root'"
        [class.panel-admin-item]="item.id === 'panel-admin'"
      [routerLink]="!item.image && !item.useAvatar ? item.routerLink : null"
      [routerLinkActive]="!item.image && !item.useAvatar ? 'active-link' : ''"
      [ngClass]="{ 'active': (!item.image && !item.useAvatar && expanded) || isActive, 'collapsed': !isSidebarOpen }"
      (click)="handleClick($event)"
    >
      <div class="item-content">
        @if (item.useAvatar && item.employeeId) {
          <app-avatar
            [employeeId]="item.employeeId"
            [name]="item.label"
            [size]="50"
            [showInfo]="false"
            class="item-icon avatar-icon">
          </app-avatar>
        } @else if (item.image) {
          <img [src]="item.image" [alt]="item.labelKey | transloco" class="item-icon">
        } @else if (item.svgIcon) {
          <span class="item-icon custom-svg" [innerHTML]="getSanitizedSvg(item.svgIcon)"></span>
        } @else if (item.icon) {
          <lucide-icon [name]="item.icon" class="item-icon"></lucide-icon>
        }
        @if (isSidebarOpen) {
          @if (item.useAvatar || item.image) {
            <div class="label-wrapper">
              <span class="item-label">{{ item.label }}</span>
              <p class="profile-subtitle">{{ item.subtitle }}</p>
            </div>
          } @else {
            <span class="item-label">{{ (item.labelKey || item.label) | transloco }}</span>
          }
        }

        <!-- Hover icon only for items WITHOUT a submenu -->
        @if (isSidebarOpen && !item.image && !item.useAvatar && item.id !== 'profile' && !item.items) {
          <lucide-icon name="ChevronRight" class="item-icon chevron-icon hover-arrow"></lucide-icon>
        }
      </div>
    </a>
  }
}

<!-- Inline submenu for expanded sidebar (except for profile which always uses floating) -->
@if (expanded && item.items && isSidebarOpen && item.id !== 'profile') {
  <ul class="sub-menu">
    @for (subItem of item.items; track subItem.id) {
      <li>
        <app-item-menu
          [item]="subItem"
          [isSidebarOpen]="true"
          (itemClick)="itemClick.emit($event)">
        </app-item-menu>
      </li>
    }
  </ul>
}

<!-- Floating submenu for collapsed sidebar -->
<ng-template #submenuTemplate>
  <ul class="sub-menu-floating" [class.profile-submenu]="item.id === 'profile'" [class.config-submenu]="item.id === 'configuration'">
    @for (subItem of item.items; track subItem.id) {
      @if (subItem.separator) {
        <li class="submenu-separator"></li>
      } @else if (subItem.id === 'profile-header') {
        <li class="profile-header-item">
          <div class="item-content">
            @if (subItem.useAvatar && subItem.employeeId) {
              <app-avatar 
                [employeeId]="subItem.employeeId" 
                [name]="subItem.label" 
                [size]="48" 
                [showInfo]="false"
                class="item-icon avatar-icon">
              </app-avatar>
            } @else if (subItem.image) {
              <img [src]="subItem.image" [alt]="subItem.label" class="item-icon">
            }
            <div class="label-wrapper">
              <span class="item-label">{{ subItem.label }}</span>
              <p class="profile-subtitle">{{ subItem.subtitle }}</p>
            </div>
          </div>
        </li>
      } @else {
        <li>
          <app-item-menu
            [item]="subItem"
            [isSidebarOpen]="true"
            (itemClick)="itemClick.emit($event)">
          </app-item-menu>
        </li>
      }
    }
  </ul>
</ng-template>
